




























































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import {
  InstallmentModel,
  InteractionModel,
  PaymentInfoModel,
  RefundExternal,
  StatementModel,
  TransactionModel,
} from '@/app/shared/models';
import {
  BrcodeType,
  ClientAccountRefund,
  PaymentMethod,
  RefundType,
} from '@/app/shared/enums';
import DataTableInstallmentsSimple from '@/app/shared/components/data-tables/installments-simple.vue';
@Component({ components: { DataTableInstallmentsSimple } })
export default class DialogDevolutionComponent extends Vue {
  @Prop(Array) readonly data!: InstallmentModel[];

  private loading = false;
  private dialog = false;
  private bankData: PaymentInfoModel = new PaymentInfoModel();
  private financialInstitutionCode = { value: '', label: '' };
  private emtptyList: PaymentInfoModel[] = [new PaymentInfoModel()];
  private refundPaymentMethod = 0;
  private pixMethod: BrcodeType = 0;
  private clientRefund: ClientAccountRefund = 0;
  private enableButton = false;
  private transaction: TransactionModel = new TransactionModel();
  private showBankDataForm = false;
  private numberCredit = 0;
  private numberDebit = 0;
  private amount = 0;
  private creditAmount = 0;
  private debitAmount = 0;
  private numberInstallment = 0;
  private valueTab = '';
  private listRefundType: object[] = [];
  private listInternal: InstallmentModel[] = [];
  private listThirdParty: InstallmentModel[] = [];
  private message = '';
  private allRefundsExternal = false;
  private validAllRefundsExternal = false;
  private statemenstByContract: StatementModel[] = [];
  private multipleCovenants = 0;
  private refundsExternal: RefundExternal[] = [];

  private listInstallmentsCreditAndDebit: {
    installment: InstallmentModel;
    check: boolean;
    finishDate: Date;
  }[] = [];
  private listInstallmentNotRefund: number[] = [];
  private get refs() {
    return refsService;
  }

  private get rules() {
    return this.refs.static.rules;
  }

  private get showBankDataFormMethod() {
    return this.showBankDataForm;
  }

  private mounted() {
    this.validThirdPartyRefund();
  }

  private cleanValues() {
    this.numberCredit = 0;
    this.numberDebit = 0;
    this.amount = 0;
    this.creditAmount = 0;
    this.debitAmount = 0;
    this.numberInstallment = 0;
    this.listInstallmentsCreditAndDebit = [];
    this.dialog = false;
    this.listRefundType = [];
    this.listInternal = [];
    this.listThirdParty = [];
    this.statemenstByContract = [];
    this.allRefundsExternal = false;
    this.multipleCovenants = 0;
    this.message = '';
  }

  private async showBankData() {
    this.loading = true;
    const selecteds = this.data;
    this.listInstallmentsCreditAndDebit = [];
    const listRefunds = this.refs.modules.contract.refundsByContract;

    for (const selected of selecteds) {
      const totalValueRefunds: number = listRefunds
        .filter((refund) => refund.InstallmentId == selected.Id)
        .reduce((a, b) => a + b.Value, 0);
      selected.TotalValueRefunds = totalValueRefunds;
      const result = await this.verifyInstallmentdebitOrCredit(selected);
      this.listInstallmentsCreditAndDebit.push(result);
    }

    this.calculateValues();

    for (const selected of this.listInstallmentsCreditAndDebit) {
      const config = await this.refs.modules.contract.verifyDaysToRefundOnOrigin(
        (selected.installment?.PaymentInfos || this.emtptyList)[0].PaymentMethod
      );

      if (!config || config.Term == 0) {
        this.listRefundType = this.refs.static.paymentMethodRefunds.filter(
          (x) => x.value == this.refs.enums.RefundType.Transfer.toString()
        );
        this.enableButton = false;
        this.showBankDataForm = true;
        this.showBankDataFormMethod;
        break;
      } else {
        const daysAgo = this.refs
          .moment(new Date(), 'DD/MM/YY')
          .subtract(config.Term, 'days')
          .toDate();

        if (selected.finishDate < daysAgo) {
          this.listRefundType = this.refs.static.paymentMethodRefunds.filter(
            (x) => x.value == this.refs.enums.RefundType.Transfer.toString()
          );
          this.enableButton = false;
          this.showBankDataForm = true;
          break;
        } else {
          if (
            (selected.installment?.PaymentInfos ||
              this.emtptyList)[0].PaymentMethod.toString() ==
              this.refs.enums.PaymentMethod[
                this.refs.enums.PaymentMethod.Credit
              ] ||
            (selected.installment?.PaymentInfos ||
              this.emtptyList)[0].PaymentMethod.toString() ==
              this.refs.enums.PaymentMethod[
                this.refs.enums.PaymentMethod.BRCode
              ]
          ) {
            this.enableButton = true;
            this.showBankDataForm = false;
            this.refundPaymentMethod = RefundType.Origin;
          } else {
            this.listRefundType = this.refs.static.paymentMethodRefunds;
            this.enableButton = false;
            this.showBankDataForm = true;
          }
          if (
            (selected.installment?.PaymentInfos ||
              this.emtptyList)[0].PaymentMethod.toString() ==
            this.refs.enums.PaymentMethod[
              this.refs.enums.PaymentMethod.BankSlip
            ]
          ) {
            this.listRefundType = this.refs.static.paymentMethodRefunds.filter(
              (x) => x.value == this.refs.enums.RefundType.Transfer.toString()
            );
          }
        }
      }
    }

    this.loading = false;
  }
  private CalculateRefundValues(installment: InstallmentModel): number {
    return (installment.Value || 0) - (installment.TotalValueRefunds || 0);
  }

  private async calculateValues() {
    const checks = this.listInstallmentsCreditAndDebit.filter(
      (installment) => installment.check
    );
    const noChecks = this.listInstallmentsCreditAndDebit.filter(
      (installment) => !installment.check
    );

    this.numberCredit = 0;
    this.numberDebit = 0;
    this.creditAmount = 0;
    this.debitAmount = 0;
    this.listInstallmentNotRefund = [];

    checks.forEach((selected) => {
      let value = this.CalculateRefundValues(selected.installment);
      if (value == 0 && selected.installment.Number) {
        return this.listInstallmentNotRefund.push(selected.installment.Number);
      }
      value = selected.installment.PartialValue || value;
      this.numberDebit++;
      this.debitAmount += Number.parseFloat(value.toString());
    });
    noChecks.map((selected) => {
      let value = this.CalculateRefundValues(selected.installment);
      if (value == 0 && selected.installment.Number) {
        return this.listInstallmentNotRefund.push(selected.installment.Number);
      }
      value = selected.installment.PartialValue || value;
      this.numberCredit++;
      this.creditAmount += Number.parseFloat(value.toString());
    });
    this.numberInstallment = this.numberDebit + this.numberCredit;
    this.amount = this.debitAmount + this.creditAmount;
  }

  private async verifyInstallmentdebitOrCredit(installment: InstallmentModel) {
    let finishDate = new Date();
    await this.refs.modules.contract.loadAttemptList({
      contractId: this.refs.modules.contract.contract.Id,
      installmentId: installment.Id,
    });
    const attempts = await this.refs.modules.contract.attemptList;
    attempts.forEach((attempt) => {
      if (
        attempt.LastTransaction &&
        attempt.LastTransaction.Status &&
        this.refs.enums.TransactionStatus[attempt.LastTransaction.Status] ==
          this.refs.enums.TransactionStatus.Approved.toString()
      ) {
        finishDate = this.refs.moment(attempt.LastTransaction.Date).toDate();
      }
    });
    const currentDate = this.refs
      .moment(new Date(), 'DD/MM/YY')
      .subtract(1, 'year')
      .toDate();
    const paymentMethod = (installment?.PaymentInfos || this.emtptyList)[0]
      .PaymentMethod;
    if (
      finishDate < currentDate ||
      paymentMethod.toString() !=
        this.refs.enums.PaymentMethod[this.refs.enums.PaymentMethod.Credit]
    ) {
      return { installment, check: true, finishDate };
    } else {
      return { installment, check: false, finishDate };
    }
  }

  private enableButtonRefund() {
    if (this.refundPaymentMethod == this.refs.enums.RefundType.Origin) {
      this.enableButton = true;
    } else if (
      this.refundPaymentMethod == this.refs.enums.RefundType.Transfer
    ) {
      if (
        this.financialInstitutionCode != undefined &&
        this.bankData.BranchNumber != undefined &&
        this.bankData.BranchNumber.length > 1 &&
        this.bankData.AccountNumber != undefined &&
        this.bankData.AccountNumber.length > 1 &&
        this.bankData.AccountDigit != undefined &&
        this.bankData.AccountDigit.length > 0 &&
        this.bankData.AccountType != undefined &&
        this.bankData.AccountType.length > 0
      )
        this.enableButton = true;
      else this.enableButton = false;
    } else {
      switch (this.pixMethod.toString()) {
        case this.refs.enums.BrcodeType[this.refs.enums.BrcodeType.Cpf]: {
          if (
            this.rules.cpf(
              this.bankData.Document != undefined ? this.bankData.Document : ''
            ) == true
          ) {
            this.bankData.DocumentType = 'CPF';
            this.enableButton = true;
          } else {
            this.enableButton = false;
          }
          break;
        }
        case this.refs.enums.BrcodeType[this.refs.enums.BrcodeType.Cnpj]: {
          if (
            this.rules.cnpj(
              this.bankData.Document != undefined ? this.bankData.Document : ''
            ) == true
          ) {
            this.bankData.DocumentType = 'CNPJ';
            this.enableButton = true;
          } else {
            this.enableButton = false;
          }
          break;
        }
        case this.refs.enums.BrcodeType[this.refs.enums.BrcodeType.Email]: {
          if (
            this.rules.email(
              this.bankData.Email != undefined ? this.bankData.Email : ''
            ) == true
          ) {
            this.enableButton = true;
          } else {
            this.enableButton = false;
          }
          break;
        }
        case this.refs.enums.BrcodeType[this.refs.enums.BrcodeType.Phone]: {
          if (this.bankData.Phone && this.bankData.Phone.length == 11) {
            this.enableButton = true;
          } else {
            this.enableButton = false;
          }
          break;
        }
        case this.refs.enums.BrcodeType[this.refs.enums.BrcodeType.Account]: {
          if (
            this.bankData.BranchNumber != undefined &&
            this.bankData.BranchNumber.length > 1 &&
            this.bankData.AccountNumber != undefined &&
            this.bankData.AccountNumber.length > 1 &&
            this.bankData.AccountDigit != undefined &&
            this.bankData.AccountDigit.length > 0
          ) {
            this.enableButton = true;
          } else {
            this.enableButton = false;
          }
          break;
        }
        case this.refs.enums.BrcodeType[this.refs.enums.BrcodeType.RandomKey]: {
          if (this.bankData.RandomKey && this.bankData.RandomKey.length >= 32) {
            this.enableButton = true;
          } else {
            this.enableButton = false;
          }
          break;
        }
        default:
          this.enableButton = false;
          break;
      }
    }
  }
  private disableButtonRefund() {
    this.enableButton = false;
  }

  private async refundInstallment() {
    if (!this.valueTab) {
      this.$nextTick(() => {
        const el = document.querySelector(
          '.v-messages.error--text:first-of-type'
        );
        if (el) {
          el.scrollIntoView();
        }
      });
      this.$toast(this.$t('toasts.incomplete_or_invalid_fields'));
      return;
    }
    this.loading = true;

    await this.refs.modules.contract
      .refundInstallment({
        installments: this.data,
        paymentInfo: this.bankData,
        financialInstitutionCode: this.financialInstitutionCode || {
          value: '',
          label: '',
        },
        refundPaymentMethod: this.refundPaymentMethod,
        pixType: this.pixMethod,
        markOff: false,
        reason: this.valueTab,
        allRefundsExternal: this.validAllRefundsExternal
          ? this.validAllRefundsExternal
          : this.allRefundsExternal,
      })
      .then(async () => {
        this.refs.modules.ticket.SET_EDIT_INSTALLMENT_GENERATE(true);
        this.refs.modules.ticket
          .createInteraction(
            new InteractionModel(
              this.$t('action_code.ac11'),
              this.$t('action_desc.ad27') +
                (this.valueTab ? ' (' + this.valueTab + ')' : '')
            )
          )
          .then(() => {
            localStorage.removeItem('tabulacao');
            this.$bus.$emit('cleanValueTab');
          });
        this.$toast(this.$t('toasts.devolution_installment_successfully'));
        await this.refs.modules.contract.loadInstallmentList(
          this.$route.params.id
        );
        if (this.refs.modules.contract.contract.Number) {
          this.refs.modules.contract.refundsByContractId(
            this.refs.modules.contract.contract.Number
          );
        }
        this.dialog = false;
        this.$emit('uncheckInstallmentList');
      })
      .catch((err) => {
        if (err && err.response && err.response.status === 404) {
          this.$toast.error(this.$t('toasts.installment_not_found'));
        }
        this.$toast.error(this.$t('toasts.devolution_installment_error'));
      })
      .finally(() => (this.loading = false));
  }

  public changeValueInstallment() {
    this.showBankData();
  }

  public onEdit(status: boolean) {
    this.enableButton = !status;
  }

  public async validThirdPartyRefund() {
    await this.refs.modules.contract.loadStatementsByContract();
    const statements = this.refs.modules.contract.statements;
    this.data.forEach(async (x) => {
      const statement = statements.find((s) => s.InstallmentId == x.Id);
      if (statement) {
        const covenant = await this.refs.modules.contract.loadCovenant(
          statement.CovenantId
        );
        if (covenant.Active && covenant.AccountId) this.listThirdParty.push(x);
        else if (covenant.Active && !covenant.AccountId)
          this.listInternal.push(x);
      }
    });

    const paymentMethodAndBillingMode: PaymentMethod[] = [];
    this.data.forEach((x) => {
      if (!paymentMethodAndBillingMode.find((x1) => x1 == x.PaymentMethod))
        paymentMethodAndBillingMode.push(
          x.PaymentMethod || PaymentMethod.Undefined
        );
    });

    const messages: string[] = [];
    let i = 0;
    paymentMethodAndBillingMode.forEach(async (p) => {
      await this.refs.modules.contract.loadRefundSettings(p);
      const message = this.refs.modules.contract.refundSettings
        .ConfigurationMessage;
      if (message) messages.push(message);
      i++;
      if (i == paymentMethodAndBillingMode.length) {
        this.message = Array.from(new Set(messages)).join(';');
      }
    });
  }

  public async loadCovenant(statement: StatementModel) {
    return await this.refs.modules.contract.loadCovenant(statement.CovenantId);
  }

  private async validExternalRefund() {
    let external = false;

    const statementRefund = this.statemenstByContract.filter((x) =>
      this.refs.modules.contract.installmentSelectedList.find(
        (d) => d.Id == x.InstallmentId
      )
    )[0];
    if (statementRefund) {
      const covenant = await this.loadCovenant(statementRefund);
      if (covenant) {
        this.refundsExternal = await this.refs.modules.contract.loadRefundExternal(
          covenant.Id
        );
        if (this.refundsExternal && this.refundsExternal.length > 0) {
          const refundExternal = this.refundsExternal[0];
          external = refundExternal.AllRefunds
            ? refundExternal.AllRefunds
            : false;
        } else {
          this.allRefundsExternal = false;
        }
      }
    }

    const covenants = this.statemenstByContract
      .filter((x) =>
        this.refs.modules.contract.installmentSelectedList.find(
          (d) => d.Id == x.InstallmentId
        )
      )
      .map((x) => x.CovenantId);

    const distinctCovenants = [...new Set(covenants)];

    if (distinctCovenants.length > 1) {
      this.multipleCovenants = distinctCovenants.length;
    }

    this.validAllRefundsExternal = external;
  }

  @Watch('refundPaymentMethod')
  private onChangeRefundType() {
    this.enableButtonRefund();
  }

  @Watch('dialog')
  private onChangeDialog() {
    this.valueTab = localStorage.getItem('tabulacao') ?? '';
  }
}
